@let regularOpeningHours = metaData()['openingHours']['regularOpeningHours'];
@let holidayOpeningHours = metaData()['openingHours']['holidayOpeningHours'];
@let specialDayOpeningHours = metaData()['openingHours']['specialDayOpeningHours'];
@let notificationInfo = metaData()['openingHours']['differentOpeningHoursNotification'];


<app-website-config-form-expansion-panel [title]="'Reguläre Öffnungszeiten'" [firstMarginTop]="true">
    @for (day of regularOpeningHours; track day.day; let last = $last; let index = $index) {
    <div class="admin-row no-border-bottom ">
        <p class="admin-text day-container">{{ day.day }}</p>
        <app-website-config-opening-hours-display [day]="day"
            (onOpeningPeriodsChanged)="updateRegularOpeningHours($event, index)"></app-website-config-opening-hours-display>
    </div>
    <mat-divider></mat-divider>
    }
</app-website-config-form-expansion-panel>

<app-website-config-form-expansion-panel [title]="'Feiertage'">
    <div class="admin-row no-border-bottom admin-row-alignment">
        <mat-slide-toggle [formControl]="syncHolidayState"
            (change)="updateSyncHoliday($event.checked)"></mat-slide-toggle>
        <p class="admin-text">Ferienkalender für </p>
        <mat-form-field appearance="outline"
            style="margin-left: 0.25em; margin-right: 0.25em; width: auto; margin-bottom: -1.25em;">
            <mat-select [formControl]="stateHolidayControl" placeholder="Bundesland auswählen"
                (selectionChange)="updateHolidayState($event.value)" panelClass="admin-theme">
                <mat-option [value]="null">--</mat-option>
                @for (state of states; track state) {
                <mat-option [value]="state">
                    {{ state }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <p class="admin-text">verwenden</p>
    </div>
    @if(holidayOpeningHours.stateHoliday && holidayOpeningHours.stateHolidaySync){
    <mat-divider></mat-divider>
    <div class="admin-row no-border-bottom">
        <div class="day-container">
            <p class="admin-text">Standardzeiten für Feiertage</p>
        </div>
        <app-website-config-opening-hours-display [day]="holidayOpeningHours"
            (onOpeningPeriodsChanged)="updateHolidayDefaultOpeningHours($event)"></app-website-config-opening-hours-display>
    </div>
    <app-website-config-form-expansion-panel [title]="'Feiertagskalender'" [noMargin]="true">
        @for(day of holidayOpeningHours.days; track day; let index = $index;) {
        <div class="admin-row no-border-bottom">
            <div class="day-name-container">
                <p class="admin-text" style="font-weight: bold;">{{ day.date }}</p>
                <p class="admin-text">{{ day.displayName }}</p>
            </div>
            @if(isHolidaySpecialDay(day)) {
            <mat-icon
                matTooltip="Feiertage, die bereits als Urlaubstag angegeben sind, können nicht bearbeitet werden. Bearbeite die Öffnungszeiten für diesen Tag unter Urlaub/Feiertage."
                matTooltipClass="admin-tooltip" class="error">info</mat-icon>
            <p class="admin-text error">Als Urlaubstag konfiguriert</p>
            }
            @else {
            <app-website-config-opening-hours-display class="cell-double-width" [day]="day"
                (onOpeningPeriodsChanged)="updateHolidayDateOpeningHours($event, index)"></app-website-config-opening-hours-display>
            <mat-checkbox class="cell" [checked]="day.syncWithDefaultPeriods"
                (change)="updateSyncWithDefaultPeriods($event.checked, index)">
                Mit Standardöffnungszeiten synchronisieren
            </mat-checkbox>
            }
        </div>
        <mat-divider></mat-divider>
        }
    </app-website-config-form-expansion-panel>
    }
</app-website-config-form-expansion-panel>

<app-website-config-form-expansion-panel [title]="'Urlaub/Besondere Tage'">
    @for (day of specialDayOpeningHours; track day; let index = $index) {
    <div class="admin-row no-border-bottom distribution-row">
        <div class="admin-row-element">
            <div class="day-name-container special-day">
                <p class="admin-text" style="font-weight: bold;">{{ day.date }}</p>
            </div>
            <app-website-config-opening-hours-display [day]="day"
                (onOpeningPeriodsChanged)="updateSpecialDayOpeningHours($event, index)"></app-website-config-opening-hours-display>
        </div>

        <button mat-icon-button (click)="deleteSpecialDay(day)">
            <mat-icon class="error">delete</mat-icon>
        </button>

    </div>
    <mat-divider></mat-divider>
    }
    <div class="add-action">
        <button mat-mini-fab (click)="openPicker()">
            <mat-icon class="admin-success">add</mat-icon>
        </button>
    </div>
    <div class="admin-row no-border-bottom">
        <mat-form-field class="hidden">
            <mat-label>Weitere Tage hinzufügen</mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="minDate" [max]="maxDate">
                <input matStartDate formControlName="start" placeholder="Von (einschließlich)">
                <input matEndDate formControlName="end" placeholder="Bis (einschließlich)">
            </mat-date-range-input>
            <mat-hint>TT/MM/JJJJ – TT/MM/JJJJ</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <div class="admin-theme">
                <mat-date-range-picker touchUi #picker panelClass="admin-theme">
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel class="admin-theme">Abbrechen</button>
                        <button mat-button matDateRangePickerApply (click)="addSpecialDays()"
                            class="admin-theme">Speichern</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </div>
            @if (range.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>Invalid start date</mat-error>
            }
            @if (range.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>Invalid end date</mat-error>
            }
        </mat-form-field>
    </div>
</app-website-config-form-expansion-panel>

<app-website-config-form-expansion-panel [title]="'Benachrichtigung über geänderte Öffnungszeiten'">
    <p class="admin-text headline">Benachrichtigungszeitraum</p>
    <div class="admin-row no-border-bottom admin-row-alignment">
        <mat-form-field appearance="outline" style="width: 8rem; margin-bottom: -1.25em;">
            <input [formControl]="notificationRange" matInput type="number" min="0" max="365" placeholder="Tage"
                (change)="updateNotificationRange($event)">
        </mat-form-field>
        <span>Tage zuvor</span>
    </div>

    <p class="admin-text headline">Benachrichtigungstext</p>
    <app-admin-user-input [editorContent]="notificationInfo.notificationText"
        (onEditorContentSaved)="updateNotificationText($event)"></app-admin-user-input>


</app-website-config-form-expansion-panel>